module.exports = __webpack_public_path__ + "static/media/insurancePdf3rdParty.3def8325.pdf";